import { memo } from "react"
import { Maybe } from "@oysterhr/schema"
import dompurify from "dompurify"

interface AssistiveTextWithHtmlProps {
  text?: Maybe<string>
  "data-testid"?: string
}

export const AssistiveTextWithHtml = memo(function AssistiveTextWithHtml({
  text,
  ["data-testid"]: dataTestId,
}: AssistiveTextWithHtmlProps) {
  return text ? (
    <span
      data-testid={dataTestId}
      className="onboarding-forms-assistive-text break-words text-base font-normal leading-6 text-gray-400"
      /* sanitized */
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{
        __html: dompurify.sanitize(text, {
          USE_PROFILES: { html: true },
          ADD_ATTR: ["target"],
        }),
      }}
    />
  ) : null
})
